import { BaseScreen } from '@goodboydigital/astro';
import { Point, Sprite, Texture } from 'pixi.js';

import { App, Shared } from '../App';
import { AnalyticsEvent } from '../plugins/AnalyticsPlugin';
import { NineSliceButton } from '../ui/buttons/NineSliceButton';
import LocalisedText from '../ui/LocalisedText';
import { Panel } from './../ui/Panel';

export class TutorialCompleteScreen extends BaseScreen
{
    public app: App;
    public bg!: Sprite;
    public title!: LocalisedText;
    public nextText!: LocalisedText;
    public homeButton!: NineSliceButton;
    public replayButton!: NineSliceButton;
    public nextButton!: NineSliceButton;
    public resultsPanel!: Panel;

    constructor(app: App)
    {
        super(app);
        this.app = app;
    }

    async init(): Promise<void>
    {
        this.bg = Sprite.from(Texture.WHITE);
        this.bg.alpha = 0;
        this.bg.width = this.bg.height = 9999;
        this.bg.anchor.set(0.5);
        this.view.addChild(this.bg);

        this.resultsPanel = new Panel({
            w: 720,
            h: 400,
        });
        this.resultsPanel.view.sortableChildren = true;
        this.view.addChild(this.resultsPanel.view);

        const homeIcon = Sprite.from(Shared.assets.getTexture('icon-home'));

        this.homeButton = new NineSliceButton({
            icon: homeIcon,
            bgAsset: 'button-ninesliced-magenta',
            w: homeIcon.width * 1.5,
            h: homeIcon.height * 1.5,
        });
        this.view.addChild(this.homeButton.view);
        this.homeButton.onPress.connect(() =>
        {
            this.app.controller.toHome();
            Shared.game.idle();
        });

        this.title = new LocalisedText('resultsScreen_tutorialCompleted', {
            fontFamily: 'lubalin',
            fill: 0xFFFFFF,
            stroke: 0x333333,
            strokeThickness: 10,
            align: 'center',
            lineJoin: 'round',
            fontSize: 44,
            maxWidth: 650,
        });
        this.title.anchor.set(0.5);
        this.resultsPanel.view.addChild(this.title);
        this.title.y -= 100;

        const replayIcon = Sprite.from(Shared.assets.getTexture('icon-replay'));

        replayIcon.anchor.set(0.5);

        this.replayButton = new NineSliceButton({
            icon: replayIcon,
            accessibleTitle: 'GO',
            bgAsset: 'button-ninesliced-yellow',
            w: 130,
            h: 130,
        });
        this.resultsPanel.view.addChild(this.replayButton.view);
        this.replayButton.view.x = -100;
        this.replayButton.view.y = 50;
        this.replayButton.onPress.connect(() => {
            this.app.analytics.trackEvent(AnalyticsEvent.TUTORIAL_REPLAY);
            this.app.controller.playPrevRace();
        });

        const next = new Sprite();
        const nextIcon = Sprite.from(Shared.assets.getTexture('icon-play'));

        next.addChild(nextIcon);
        nextIcon.anchor.set(0.5);

        this.nextButton = new NineSliceButton({
            icon: next,
            accessibleTitle: 'GO',
            bgAsset: 'button-ninesliced-yellow',
            w: 130,
            h: 130,
        });
        this.resultsPanel.view.addChild(this.nextButton.view);
        this.nextButton.view.x = 100;
        this.nextButton.view.y = 50;
        this.nextButton.onPress.connect(() => this.app.controller.playNextRace());
    }

    show(): void
    {
        this.resize(this.width, this.height);

        this.view.visible = true;
        
        this.app.analytics.trackEvent(AnalyticsEvent.TUTORIAL_COMPLETE);
    }

    hidden(): void
    {
        this.view.visible = false;
    }

    resize(w: number, h: number): void
    {
        super.resize(w, h);
        this.view.x = (this.width - this.app.width) * 0.5;
        this.view.y = (this.height - this.app.height) * 0.5;
        this.bg.position.copyFrom(this.app.stageCenter as Point);

        this.resultsPanel.view.position.copyFrom(this.app.stageCenter as Point);

        this.homeButton.view.position.set(
            this.app.stageLeft + 90,
            this.app.stageTop + 90,
        );
    }
}
